( function () {
	'use strict';

	var config = {
		'operatorGroup'      : 3,
		'filterPattern'      : /avg;\(/g,
		'replacementPattern' : ';avg(',
		'operatorKey'        : 'avg('
	};

	function run ( math ) {
		math.register( 'averageOperator', config );
	}

	angular
		.module( 'app.components' )
		.value( 'operatorAveConfig', config )
		.run( run );

	run.$inject = [ 'mathOperatorService' ];
} )();
